import { render, staticRenderFns } from "./TicketCommonNew.vue?vue&type=template&id=0dba2e89&scoped=true&"
import script from "./TicketCommonNew.vue?vue&type=script&lang=js&"
export * from "./TicketCommonNew.vue?vue&type=script&lang=js&"
import style0 from "./TicketCommonNew.vue?vue&type=style&index=0&id=0dba2e89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dba2e89",
  null
  
)

export default component.exports